import { render, staticRenderFns } from "./LogoSymbol.vue?vue&type=template&id=396faa2a&lang=html"
import script from "./LogoSymbol.vue?vue&type=script&lang=js"
export * from "./LogoSymbol.vue?vue&type=script&lang=js"
import style0 from "./LogoSymbol.vue?vue&type=style&index=0&id=396faa2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports